/**
 * @file Whether the viewport is wide enough, 1080 px or more, for the
 * analytics tabs to set their cards side by side; below it they stack.
 * Consumers: `AnalyticsOverviewChartAndPipeline`, `AnalyticsProjectDetail` and
 * `AnalyticsInvoicingPanel`. It subscribes to the
 * browser's media query through `useSyncExternalStore`, so the layout follows
 * a resize without an effect and reads the current width on first render.
 */
import { useSyncExternalStore } from 'react';

const WIDE_LAYOUT_QUERY = '(min-width: 1080px)';

const subscribe = (onChange: () => void): (() => void) => {
  const media = window.matchMedia(WIDE_LAYOUT_QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};

const isWide = (): boolean => window.matchMedia(WIDE_LAYOUT_QUERY).matches;

export const useAnalyticsWideLayout = (): boolean =>
  useSyncExternalStore(subscribe, isWide);
